import React from 'react';
import { IconProps } from '../../DefaultIcon';

export function ProfileIcon({ className }: IconProps) {
  return (
    <svg
      width="78"
      height="82"
      viewBox="0 0 78 82"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1147_1240)">
        <path
          d="M77.9508 76.8827C76.1961 63.394 67.6942 52.0666 55.9546 46.4028C51.1105 49.7067 45.2778 51.6443 39.0003 51.6443C32.7227 51.6443 26.89 49.7067 22.0459 46.4028C10.3063 52.0666 1.77973 63.394 0.0496883 76.8827C-0.296319 79.6152 1.82916 82.0248 4.5725 82.0248H73.4527C76.1961 82.0248 78.3216 79.6152 77.9755 76.8827H77.9508Z"
          fill="#00416B"
        />
        <path
          d="M60.1562 21.2639C60.1562 33.0136 50.6904 42.5277 39.0003 42.5277C27.3102 42.5277 17.8691 33.0136 17.8691 21.2639C17.8691 9.51409 27.3102 0 39.0003 0C50.6904 0 60.1562 9.51409 60.1562 21.2639Z"
          fill="#00416B"
        />
      </g>
      <defs>
        <clipPath id="clip0_1147_1240">
          <rect width="78" height="82" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
